import type { Resource } from 'i18next';

import en from './en/index';
import nl_BE from './nl-BE/index';
import fr from './fr/index';
import es from './es/index';
import de from './de/index';
import no from './no/index';
import lt from './lt/index';
import pl from './pl/index';
import tr from './tr/index';
import pt from './pt/index';
import ro from './ro/index';
import bg from './bg/index';
import it from './it/index';

/**
 * i18next resources, keyed by the LIVE marketing locale codes (DIT-399) — the
 * funnel is routable exactly where the marketing site is, so the keys here must
 * be live locale codes, not the funnel's old private list.
 *
 * Three live locales are served by a bundle whose directory is named differently:
 *
 *   nl    → `nl-BE/`  marketing `nl` is the Belgian (Flemish) locale
 *                     (`market: "belgium"`), and the `nl-BE` bundle is the
 *                     genuinely Flemish copy ("werf", "arbeiders", "verlof")
 *                     rather than the generic Dutch in `nl/`.
 *   fr-be → `fr/`     Belgian French is the only French market we serve.
 *   en-be → `en/`     mirrors the marketing site, where en-be has no own
 *                     catalogs and resolves through the English source.
 *
 * `nl/`, `nl-NL/` and `en-NZ/` stay on disk (the project ships 16 locale
 * directories) but are no longer routable prefixes — see LEGACY_LANG_ALIASES in
 * shared/config/i18n.ts, which redirects those URLs to the live locale above.
 *
 * Typed as i18next's `Resource`, not `Record<string, typeof en>`: bundles are
 * allowed to lag the English source (that is what `fallbackLng` is for), and
 * pinning every locale to `en`'s exact shape turns any en-only key into an
 * unrelated-looking build break in this file.
 */
export const RESOURCES: Resource = {
  en,
  nl: nl_BE,
  'fr-be': fr,
  'en-be': en,
  es,
  de,
  it,
  pt,
  pl,
  ro,
  no,
  bg,
  tr,
  lt,
};
